import { gql } from "@apollo/client";

export const GET_READERS = gql`
  query getReaders($lang_id: ID!, $class_id: ID!, $reader_type: String) {
    books(
      lang_id: $lang_id
      class_id: $class_id
      published_only: true
      order: "level_id"
      reader_type: $reader_type
    ) {
      id
      disabled
      glossary_less
      title
      url
      total_ratings
      print_url
      level_id
      rank
      rating
      rating_teachers
      rating_students
      images {
        thumb
        cover
      }
      level {
        id
        name
      }
      language {
        id
        name
      }
      categories {
        id
        name
      }
    }
  }
`;

export const GET_CLASSES = gql`
  query {
    classes {
      value: id
      txt: name
      students
      created
    }
  }
`;

export const DISABLE_BOOKS = gql`
  mutation disableBooks(
    $books_ids: [ID!]!
    $class_id: ID!
    $disable: Boolean!
    $reader_type: String
  ) {
    disableBooks(
      books_id: $books_ids
      class_id: $class_id
      disable: $disable
      reader_type: $reader_type
    )
  }
`;

export const TOGGLE_GLOSSARY = gql`
  mutation glssaryToggle(
    $show_less: Boolean!
    $books_ids: [ID]!
    $class_id: ID!
  ) {
    glssaryToggle(
      show_less: $show_less
      class_id: $class_id
      books_id: $books_ids
    )
  }
`;
